import type { CSSProperties } from 'react'

// SnapTransfer extension — not in the reference library.
// The wordmark mark-only glyph. Used on public download/request headers
// where the full Logo text isn't wanted. Props let public pages override
// the fill so a branded transfer can recolor the mark to the tenant accent.
interface LogoMarkProps {
  size?: number
  borderColor?: string
  background?: string
  shadow?: string | false
  rotate?: number
  style?: CSSProperties
}

export function LogoMark({
  size = 44,
  borderColor = 'var(--ink)',
  background = 'var(--accent)',
  shadow = 'var(--shadow-sm)',
  rotate = -4,
  style
}: LogoMarkProps) {
  const inner = Math.round(size * 0.6)
  return (
    <span
      style={{
        width: size,
        height: size,
        border: `var(--border) solid ${borderColor}`,
        background,
        boxShadow: shadow || undefined,
        display: 'grid',
        placeItems: 'center',
        // perspective() forces WebKit's anti-aliased 3D-composited path so the
        // rotated border + hard shadow don't stair-step in the desktop
        // WKWebView. Z-only rotation, so it's geometrically a no-op (and a
        // no-op in Chrome). See the note on `.st-title em` in components.css.
        transform: `perspective(1000px) rotate(${rotate}deg)`,
        flex: 'none',
        ...style
      }}>
      <svg
        width={inner}
        height={inner}
        viewBox="0 0 24 24"
        fill="none"
        stroke="#0a0a0a"
        strokeWidth="3"
        strokeLinecap="square">
        <path d="M4 14 L12 6 L20 14" />
        <path d="M12 6 L12 20" />
      </svg>
    </span>
  )
}
